import { render, staticRenderFns } from "./PnlAttributes.vue?vue&type=template&id=36d1a05d&scoped=true"
import script from "./PnlAttributes.vue?vue&type=script&lang=js"
export * from "./PnlAttributes.vue?vue&type=script&lang=js"
import style0 from "./PnlAttributes.vue?vue&type=style&index=0&id=36d1a05d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1a05d",
  null
  
)

export default component.exports